export const CANCEL_REASONS = [
  { value: "illness", label: "Hastalık" },
  { value: "excused", label: "Mazeretli (önceden haber verdi)" },
  { value: "no_show", label: "Gelmedi" },
  { value: "vacation", label: "Tatil / İzin" },
  { value: "weather", label: "Hava durumu" },
  { value: "business", label: "İşletme kaynaklı" },
  { value: "trainer", label: "Antrenör kaynaklı" },
  { value: "other", label: "Diğer" },
];
